module.exports = __webpack_public_path__ + "static/media/calendarBlue.4d294962.svg";